/* eslint-disable react-refresh/only-export-components */
import styled, { css } from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { imgOnError } from '../../../../shared/helpers';
import i18n from '../../../../app/i18n';
import PercentBar from '../../../../shared/PercentBar';
import Text from '../../../../shared/Text';

const iconCellStyle = css`
  padding: 0 0 0 24px;
  justify-content: flex-start;
`;

const baseStyle = css`
  padding: 0 24px 0 0;
`;

const rightAligned = css`
  ${baseStyle};
  justify-content: flex-end;
`;

export const TableIcon = styled.img`
  height: 24px;
  width: 24px;
  border-radius: 15%;
  background: ${themeGet('colors.black.10')};
  border: none;
  margin-top: 0px;
  vertical-align: middle;
`;

export const ImageTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LeftImg = styled.img`
  margin-right: 4px;
`;

export const RightImg = styled.img`
  margin-left: 4px;
`;

export const columns = [
  {
    title: i18n.t('reports:engagementTable.tile'),
    tooltipText: i18n.t('reports:engagementTable.tileTooltip'),

    width: '70px',
    padding: '0 16px 0 24px',
    columnName: 'tile',
    tooltipStyle: 'engagement-table',
  },
  {
    title: i18n.t('reports:engagementTable.headline'),
    tooltipText: i18n.t('reports:engagementTable.headlineTooltip'),

    width: '443px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'headline',
    tooltipStyle: 'engagement-table',
  },
  {
    title: i18n.t('reports:engagementTable.topic'),
    tooltipText: i18n.t('reports:engagementTable.topicTooltip'),

    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'topic',
    tooltipStyle: 'engagement-table',
  },
  {
    title: i18n.t('reports:engagementTable.duration'),
    tooltipText: i18n.t('reports:engagementTable.durationTooltip'),

    width: '103px',
    padding: '0 24px 0 0',
    alignment: 'right',
    sortable: true,
    sortLocation: 'right',
    columnName: 'duration',
    tooltipStyle: 'engagement-table',
    tooltipOffset: "{'left': 25}",
  },
  {
    title: i18n.t('reports:engagementTable.people'),
    width: '87px',
    padding: '0 24px 0 0',
    alignment: 'right',
    sortable: true,
    sortLocation: 'right',
    columnName: 'people',
    tooltipStyle: 'engagement-table',
    tooltipText: i18n.t('reports:engagementTable.peopleTooltip'),
  },
  {
    title: i18n.t('reports:engagementTable.views'),
    width: '80px',
    padding: '0 24px 0 0',
    alignment: 'right',
    sortable: true,
    sortLocation: 'right',
    columnName: 'views',
    tooltipStyle: 'engagement-table',
    tooltipText: i18n.t('reports:engagementTable.viewsTooltip'),
  },
  {
    title: i18n.t('reports:engagementTable.clicks'),
    width: '105px',
    padding: '0 24px 0 0',
    alignment: 'right',
    sortable: true,
    sortLocation: 'right',
    columnName: 'clicks',
    tooltipStyle: 'engagement-table',
    tooltipText: i18n.t('reports:engagementTable.clicksTooltip'),
  },
  {
    title: i18n.t('reports:engagementTable.completes'),
    width: '116px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'right',
    columnName: 'completes',
    alignment: 'right',
    tooltipStyle: 'engagement-table',
    tooltipText: i18n.t('reports:engagementTable.completesTooltip'),
  },
  {
    title: i18n.t('reports:engagementTable.engagement'),
    width: '131px',
    padding: '0 24px 0 0',
    alignment: 'right',
    sortable: true,
    sortLocation: 'right',
    columnName: 'engagement',
    tooltipStyle: 'engagement-table',
    tooltipText: i18n.t('reports:engagementTable.engagementTooltip'),
    tooltipOffset: "{'left': 150}",
  },
];

export const engagementBodyData = data =>
  data.map(row => ({
    info: {
      dataTileId: row.uuid,
      uuid: row.uuid,
      clickable: true,
      hasDivider: true,
      className: 'stat_action js-open-tile-stats-modal',
      dataHref: `/client_admin/tiles/${row.uuid}/tile_stats`,
    },
    cells: [
      {
        content: <TableIcon src={row.tileImage} onError={imgOnError} />,
        style: iconCellStyle,
      },
      {
        content: (
          <Text variant="small2" color="primary.100">
            {row.headline}
          </Text>
        ),
        style: baseStyle,
      },
      {
        content: (
          <Text variant="small2" color="black.100">
            {row.topic}
          </Text>
        ),
        style: baseStyle,
      },
      {
        content: (
          <ImageTextWrapper>
            <Text variant="small2" color="black.100">
              {row.durationString}
            </Text>
          </ImageTextWrapper>
        ),
        style: baseStyle,
      },
      {
        content: (
          <ImageTextWrapper>
            <Text variant="small2" color="black.100">
              {row.people}
            </Text>
          </ImageTextWrapper>
        ),
        style: rightAligned,
      },
      {
        content: (
          <Text variant="small2" color="black.100">
            {row.views}
          </Text>
        ),
        style: rightAligned,
      },
      {
        content: (
          <Text variant="small2" color="black.100">
            {row.clicks}
          </Text>
        ),
        style: rightAligned,
      },
      {
        content: (
          <Text variant="small2" color="black.100">
            {row.completes}
          </Text>
        ),
        style: rightAligned,
      },
      {
        content: <PercentBar percentage={`${row.engagement}%`} />,
        style: baseStyle,
      },
    ],
  }));
